__turbopack_context__.v({
  "container": "BlogCta-module__xXfqWW__container",
  "text": "BlogCta-module__xXfqWW__text",
  "title": "BlogCta-module__xXfqWW__title",
});
